var ip = document.querySelectorAll(".wu-input");
    
if (/complete|interactive|loaded/.test(document.readyState)) {
    stat();
    //currencyDropdownToggle();
} else {
    window.addEventListener("DOMContentLoaded", stat);
    //window.addEventListener("DOMContentLoaded", currencyDropdownToggle);
}

for (var i = 0; i < ip.length; i++) {
    if (ip[i].addEventListener) {
        ip[i].addEventListener("change", stat);
        ip[i].addEventListener("blur", stat);
    } else if (ip[i].attachEvent) {
        ip[i].attachEvent("change", stat);
        ip[i].attachEvent("blur", stat);
    }
}

function stat() {
    ip = document.querySelectorAll(".wu-input");

    for (var i = 0; i < ip.length; i++) {
        ip[i].setAttribute('value',ip[i].getAttribute('data-value'));
        if (ip[i].value != '') {
            ip[i].classList.add("wu-input--is-focus");
        } else if (ip[i].value == '') {
            ip[i].classList.remove("wu-input--is-focus");
        }
    }
}

/**
* Script to modify iframe link for prod & test sites
*/
const iFrameLink = (() => {
    const iframeSetting = document.getElementById('iframe_links');
    if( iframeSetting ) {
        let siteUrl = location.href;
        let environment = (siteUrl.indexOf('https://www.westernunion.com') !== -1) ? 'prod':'uat';
        const iframeConfig = JSON.parse(iframeSetting.innerHTML);
        let iframeHtml = document.getElementById('wuIframe');
        iframeHtml.src = iframeConfig[environment].link;
        iframeHtml.width = iframeConfig[environment].width+'%';
        iframeHtml.height = iframeConfig[environment].height+"px";
    }
})();